import React from 'react';
import { connect } from 'react-redux';
import { selectColorChoiceById, selectColorChoicesById, selectComponentById, updateValueByIds } from './_redux';
import { AppDispatch, WebsiteState } from '@gift/website-state/store';
import { ColorChoice } from '@gift/attributes-color-core/ColorAttributeOptions';
import { ColorAttributeDropdown } from './partials/ColorAttributeDropdown';
import { ColorAttributeRadioGroup } from './partials/ColorAttributeRadioGroup';

const _ColorAttributeInputControl = ({ component, ...rest }: Props) => {
    if (component === 'dropdown') {
        return <ColorAttributeDropdown {...rest} />;
    } else {
        return <ColorAttributeRadioGroup {...rest} />;
    }
};

type Props = {
    selected: ColorChoice;
    choices: ColorChoice[];
    update: (value: string) => void;
    variableIds: string[];
    component?: 'dropdown' | 'radio-group';
}

const mapStateToProps = (state: WebsiteState, ownProps: { variableIds: string[] }) => ({
    choices: selectColorChoicesById(state, ownProps.variableIds[0])!,
    selected: selectColorChoiceById(state, ownProps.variableIds[0])!,
    component: selectComponentById(state, ownProps.variableIds[0])
});

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: { variableIds: string[] }) => ({
    update: (color: string) => dispatch(updateValueByIds(ownProps.variableIds, color))
});

export const ColorAttributeInputControl = connect(
    mapStateToProps,
    mapDispatchToProps
)(_ColorAttributeInputControl);
